import { Component, Input } from '@angular/core';
import { ToggleType } from '@ddt-web/common';
import { DisplayTableColumnClassOverride, NestedTableConfig } from '@ddt-web/data-layer-components';
import { TabData } from '@ddt-web/data-service';

@Component({
	selector: 'ac-chart-table-card-item',
	templateUrl: './chart-table-card-item.component.html',
	styleUrls: ['./chart-table-card-item.component.scss']
})
export class ChartTableCardItemComponent {
	@Input() public chartData: TabData;
	@Input() public tableData: TabData;
	@Input() public dcrOptions: { key: string; default: string };
	@Input() public tooltipDcr?: string;
	@Input() public tableOptions: NestedTableConfig = {
		shouldShowExpandIconOnLeft: true,
		shouldShowSeparatorLineBelowParent: true
	};
	// when using expansion, the total cols need to be col-23 (instead of the normal col-24) - otherwise issue with alignment
	@Input() public columnClassOverride: DisplayTableColumnClassOverride = {
		categoryColumnClass: 'col-10',
		dataColumnClass: 'col-6',
		expandIconColumnClass: 'col-1',
		iconColumnClass: 'col-1'
	};
	public readonly toggleType = ToggleType;
	public componentState: ToggleType = ToggleType.Chart;

	public toggleChange(event: ToggleType): void {
		this.componentState = event;
	}
}
